import React, { useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, Button, Tooltip } from "@heroui/react";
import { FaImage } from "react-icons/fa";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import PropTypes from "prop-types";

const ImageViewer = ({ images }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // const formattedImages = images.map((img) => `data:image/jpeg;base64,${img.image}`);
  const formattedImages = images.map((img) => `${img.image}`);

  return (
    <>
      <Tooltip content="نمایش تصاویر" placement="top" color={"primary"}>
  <span>
    <FaImage
      className="text-blue-600 cursor-pointer hover:text-blue-800 transition text-xl"
      onClick={() => setIsOpen(true)}
    />
  </span>
      </Tooltip>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="lg" backdrop="blur">
        <ModalContent className="p-4 rounded-2xl shadow-xl bg-white">
          <ModalHeader className="flex flex-col gap-1">
            <span className="text-lg font-semibold">تصاویر</span>
            <span className="text-sm text-gray-500">{formattedImages.length} تصویر</span>
          </ModalHeader>

          <ModalBody>
            <div
              className={`grid gap-4 ${
                formattedImages.length === 1 ? "grid-cols-1" : "grid-cols-2"
              }`}
            >
              {formattedImages.map((src, index) => (
                <div
                  key={index}
                  className="relative group cursor-pointer rounded-lg overflow-hidden shadow-md"
                  onClick={() => {
                    setCurrentIndex(index);
                    setLightboxOpen(true);
                  }}
                >
                  <img
                    src={src}
                    alt={`تصویر ${index + 1}`}
                    className="w-full aspect-video object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition" />
                </div>
              ))}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>


      {lightboxOpen && (
        <Lightbox
          mainSrc={formattedImages[currentIndex]}
          nextSrc={formattedImages[(currentIndex + 1) % formattedImages.length]}
          prevSrc={
            formattedImages[
            (currentIndex + formattedImages.length - 1) % formattedImages.length
              ]
          }
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setCurrentIndex((currentIndex + formattedImages.length - 1) % formattedImages.length)
          }
          onMoveNextRequest={() =>
            setCurrentIndex((currentIndex + 1) % formattedImages.length)
          }
        />
      )}
    </>
  );
};

ImageViewer.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
};
export default ImageViewer;
